import Image from "@common/controls/Image/component";
import { type OptionItem, type WithOnChange, type WithOnChangeDelay, type WithOptions, type WithValue } from "@common/declarations";
import { type FocusBlurSharedProps } from "@common/hocs/withFocusBlur";
import withValueHOC from "@common/hocs/withValue";
import { default as classNames, default as classnames } from "classnames";
import * as React from "react";
import { FancyCheckbox } from "../Inputs/Checkbox/component";
import { getValues } from "./lib";

import "./style.less";

type CheckboxOptionItem = OptionItem<string> & {
  className?: string;
};

type Value = string[] | string;
export type CheckboxGroupProps = WithOptions<CheckboxOptionItem> &
  WithValue<Value> &
  WithOnChange<Value> &
  WithOnChangeDelay &
  FocusBlurSharedProps & {
    id?: string;
    isDisabled?: boolean;
    name?: string;
    className?: string;
    isLoading?: boolean;
  };

class CheckboxGroupInner extends React.PureComponent<CheckboxGroupProps> {
  public render() {
    const { className, options, value, onBlur, onFocus, isDisabled, isLoading } = this.props;
    const values = getValues(value);

    return (
      <div
        className={classnames("wsc_checkbox_group", className, { wsc_loading_container: isLoading })}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {options.map((item) => (
          <FancyCheckbox
            className={classNames("item", item.className)}
            key={item.value}
            htmlValue={item.value}
            onChange={this._onChange(item.value)}
            label={item.label}
            image={item.image ? <Image className="img-thumbnail" title={item.label} src={item.image} /> : null}
            isDisabled={isDisabled}
            value={values.has(item.value)}
          />
        ))}
      </div>
    );
  }

  private _onChange(itemValue: string) {
    return (isChecked: boolean) => {
      if (this.props.isDisabled) return;

      const values = getValues(this.props.value);

      if (isChecked) {
        values.add(itemValue);
      } else {
        values.delete(itemValue);
      }

      const value = Array.from(values).sort();
      this.props.onChange(typeof this.props.value === "string" ? value.toString() : value);
    };
  }
}
const CheckboxGroup = withValueHOC<Value, CheckboxGroupProps>(CheckboxGroupInner);
export default CheckboxGroup;
